import { z } from "zod";
export const PROVIDER_KINDS = [
    "tts",
    "stt",
    "video",
    "image",
    "messaging",
    "asset_source",
    "search",
    "embedding",
];
export const ProviderKindSchema = z.enum(PROVIDER_KINDS);
export const ProviderDescriptorSchema = z.object({
    id: z.string().min(1),
    kind: ProviderKindSchema,
    runsIn: z.enum(["server", "browser", "cloud"]),
    paid: z.boolean(),
    /** BCP-47 tags or "*" for language-independent providers. */
    languages: z.array(z.string().min(1)),
    /** e.g. { streaming: true, cloning: false, preview: true } */
    capabilities: z.record(z.string(), z.boolean()),
});
//# sourceMappingURL=providers.js.map